<template>
	<transition name="system-content-slide">
		<div v-show="isShow" class="chat-system-content">
			<el-container>
				<el-header height="60px" :class="configStore.electronMode ? 'header-menu-wrap' : ''">
					<span class="back" @click="onBack()">
						<i class="el-icon-arrow-left"></i>
						<span>{{ $t('common.back') }}</span>
					</span>
					<span class="header-title">{{ title }}</span>
				</el-header>
				<el-main class="content-main">
					<div v-if="contentType == 0" class="rich-text-wrap">
						<div class="rich-text" v-html="richText"></div>
					</div>
					<iframe v-else class="ext-link" :src="externLink"></iframe>
				</el-main>
			</el-container>
		</div>
	</transition>
</template>

<script>
import { Base64 } from 'js-base64';

export default {
	name: "chatSystemContent",
	data() {
		return {
			isShow: false,
			title: "",
			contentType: 0,
			richText: "",
			externLink: ""
		}
	},
	methods: {
		show(id, title) {
			this.$http({
				url: '/message/system/content?id=' + id,
				method: 'get',
			}).then(message => {
				this.title = title;
				this.richText = Base64.decode(message.richText);
				this.externLink = message.externLink;
				this.contentType = message.contentType;
				this.isShow = true;
			})
		},
		onBack() {
			this.isShow = false;
		}
	}
}
</script>

<style lang="scss">
.chat-system-content {
	position: absolute;
	top: 0;
	left: 0;
	background-color: var(--im-background-page);
	width: 100%;
	height: 100%;
	z-index: 10;

	.el-header {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0 20px;
		line-height: 60px;
		border-bottom: var(--im-border);
		background: var(--im-background);
		position: relative;

		.back {
			position: absolute;
			left: 16px;
			display: flex;
			align-items: center;
			gap: 4px;
			font-size: var(--im-font-size);
			color: var(--im-color-primary);
			cursor: pointer;
			padding: 6px 10px;
			border-radius: 8px;
			transition: background 0.2s ease;

			&:hover {
				background: var(--im-background-active);
			}

			i {
				font-size: 16px;
			}
		}

		.header-title {
			font-size: var(--im-font-size-large);
			font-weight: 600;
			color: var(--im-text-color);
			max-width: 60%;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}

	.content-main {
		padding: 0;
		overflow: hidden;
		display: flex;
		flex-direction: column;

		.rich-text-wrap {
			flex: 1;
			overflow-y: auto;
			padding: 24px 32px 32px;
		}

		.rich-text {
			max-width: 720px;
			margin: 0 auto;
			font-size: var(--im-font-size);
			color: var(--im-text-color);
			line-height: 1.75;
			word-break: break-word;

			img {
				max-width: 100%;
				height: auto;
				border-radius: 8px;
				margin: 8px 0;
			}

			p {
				margin: 0 0 12px;
			}

			h1, h2, h3, h4 {
				color: var(--im-text-color);
				margin: 20px 0 12px;
				line-height: 1.4;
			}

			a {
				color: var(--im-color-primary);
				text-decoration: none;

				&:hover {
					text-decoration: underline;
				}
			}

			ul, ol {
				padding-left: 24px;
				margin: 0 0 12px;
			}

			blockquote {
				margin: 12px 0;
				padding: 12px 16px;
				border-left: 3px solid var(--im-color-primary-light-3);
				background: var(--im-background-active);
				border-radius: 0 8px 8px 0;
				color: var(--im-text-color-light);
			}
		}

		.ext-link {
			flex: 1;
			width: 100%;
			border: none;
		}
	}
}

.system-content-slide-enter-active,
.system-content-slide-leave-active {
	transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1),
		opacity 0.28s ease;
}

.system-content-slide-enter,
.system-content-slide-leave-to {
	transform: translateX(100%);
	opacity: 0;
}
</style>
